import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <footer class="bg-[#070708] border-t border-white/10 text-zinc-400 py-12">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        <div class="grid grid-cols-1 md:grid-cols-12 gap-8">
          <!-- Coluna 1: Marca & Descrição (5 colunas) -->
          <div class="md:col-span-5 space-y-3">
            <div class="flex items-center space-x-2 text-white font-bold">
              <span class="material-symbols-outlined text-[#F27D26] text-2xl">router</span>
              <span class="text-white font-semibold text-base">Empreendedorismo em <span class="text-[#F27D26] font-serif italic">Redes</span></span>
            </div>
            <p class="text-xs text-zinc-400 leading-relaxed max-w-sm">
              Portal oficial da disciplina de Empreendedorismo com foco em inovação em TIC (Carga Horária: 40h).
            </p>
          </div>

          <!-- Coluna 2: Estrutura das Sprints (4 colunas) -->
          <div class="md:col-span-4">
            <h4 class="text-xs font-mono font-bold uppercase tracking-wider text-zinc-200 mb-3">Estrutura das Sprints</h4>
            <ul class="space-y-2 text-xs">
              <li class="hover:text-white transition-colors"><span class="text-[#F27D26] font-mono font-semibold">Sprint 1:</span> O 'Hardware' (Perfil & Radar)</li>
              <li class="hover:text-white transition-colors"><span class="text-[#F27D26] font-mono font-semibold">Sprint 2:</span> A Infraestrutura & Ecossistema</li>
              <li class="hover:text-white transition-colors"><span class="text-[#F27D26] font-mono font-semibold">Sprint 3:</span> O Protocolo Ágil (Lean & MVP)</li>
              <li class="hover:text-white transition-colors"><span class="text-[#F27D26] font-mono font-semibold">Sprint 4:</span> O 'Deploy' do Modelo (Canvas)</li>
            </ul>
          </div>

          <!-- Coluna 3: Atividades Especiais & Aulas (3 colunas) -->
          <div class="md:col-span-3">
            <h4 class="text-xs font-mono font-bold uppercase tracking-wider text-zinc-200 mb-3">Atividades Especiais & Aulas</h4>
            <ul class="space-y-2 text-xs text-zinc-400">
              <li class="hover:text-white transition-colors">• Aula 1: Alinhamento Metodológico</li>
              <li class="hover:text-white transition-colors">• Dinâmica das Dores em Redes</li>
              <li class="hover:text-white transition-colors">• Simulador de Modelo de Canvas 9-Block</li>
              <li class="hover:text-white transition-colors">• Diagnóstico do Core Empreendedor</li>
            </ul>
          </div>
        </div>

        <!-- Linha Inferior de Copyright & Status -->
        <div class="pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between text-xs text-zinc-500 space-y-3 sm:space-y-0">
          <p>© Disciplina de Empreendedorismo em Redes • Material Didático e Projetos Integradores</p>
          <div class="flex items-center space-x-2">
            <span class="w-2 h-2 rounded-full bg-emerald-500"></span>
            <span class="font-mono text-zinc-400 text-[11px]">Servidor Ativo • Status 200 OK</span>
          </div>
        </div>
      </div>
    </footer>
  `
})
export class FooterComponent {}
